import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type SetInDislikelistMutationVariables = Types.Exact<{
	input: Types.SetInTitleListInput;
}>;

export type SetInDislikelistMutation = {
	__typename?: 'Mutation';
	setInDislikelist: {
		__typename?: 'SetInTitleListSeasonPayload';
		title:
			| {
					__typename?: 'Movie';
					id: string;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| {
					__typename?: 'Season';
					id: string;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| {
					__typename?: 'Show';
					id: string;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  };
	};
};

export const SetInDislikelistDocument = gql`
	mutation SetInDislikelist($input: SetInTitleListInput!) {
		setInDislikelist(input: $input) {
			title {
				id
				dislikelistEntry {
					createdAt
				}
				likelistEntry {
					createdAt
				}
			}
		}
	}
`;
